import { CoverageDetailed } from "../type/coverage";

export function transformCoverageLayers(coverageDetailed: CoverageDetailed) {
  const layers = Object.values(coverageDetailed.layers).map((layer) => {
    const product = coverageDetailed.products[layer.product_id];
    return {
      category_name: layer.category_name,
      delivery_method: product.delivery_method,
      area_in_sqm: layer.area_in_sqm,
      acquired_at: layer.acquired_at
        ? new Date(layer.acquired_at * 1000).toISOString()
        : null,
    };
  });

  layers.push(
    ...coverageDetailed.global_coverage.map((l) => ({
      ...l,
      acquired_at: l.acquired_at
        ? new Date(l.acquired_at * 1000).toISOString()
        : null,
    }))
  );

  return layers;
}
